export default "__VITE_ASSET__DgYHBSw5__"